
export const LOGIN_URL = '/contactcentre/login/'
export const USER_DETAILS = '/contactcentre/reauth/agent/'
export const AGENT_ACTIVITY = '/contactcentre/agent/activity/'
export const CUSTOMER_DETAILS = '/contactcentre/get-customer-detail/'
export const CALL_COUNT = '/contactcentre/call_count/'
export const CAMPAGIN_DATA = '/contactcentre/campaign-list/'
export const FEEDBACK = '/contactcentre/customer-feedback/'
export const CAMP_CONTROLL = '/contactcentre/campaign-controll/'
export const ADMIN_DASH_AGENTACTIVITY = '/contactcentre/agent_status/25/'
export const BREAK_REASONS = 'usermanagement/agent-break-reason/'
export const COMMENT_URL = '/comment/'
export const ADD_COMMENT_URL = '/contactcentre/add-comment/'
export const FOLLOWUP_REPORT_URL = '/contactcentre/FollowUpReportContactcenter/'
export const FOLLOWUP_BADGES_URL = '/contactcentre/followup-badges/'
export const REPORT_TAG_MAIN_URL = '/report_tag_main/'
export const REPORT_TAG_CHILD_URL = '/report_tag_child/'
export const FEEDBACK_DETAILS = '/contactcentre/GetCustomerDataNEW/'

